export const LogoMark = ({ size = 40, className = "" }) => (
  <img
    src="/brand-mark.jpg"
    width={size}
    height={size}
    alt="Logo ufficiale A.C. HUB"
    className={`brand-orbit rounded-full border border-[#c9a45c]/35 object-cover ${className}`}
    aria-hidden="true"
  />
);

export const Logo = ({ compact = false }) => (
  <span className="flex items-center gap-3" data-testid="brand-logo">
    <LogoMark size={compact ? 36 : 42} />
    <span className="flex shrink-0 flex-col justify-center leading-none">
      <span className="whitespace-nowrap font-serif text-[20px] tracking-[0.14em] text-cream">
        A.C. <span className="text-gold">HUB</span>
      </span>
      {!compact && (
        <span className="mt-1.5 text-[8px] font-semibold uppercase tracking-[0.18em] text-[#929292]">
          <span className="block whitespace-nowrap leading-snug">Real Estate Advisory</span>
          <span className="block whitespace-nowrap leading-snug text-gold-light/80">Regia unica</span>
        </span>
      )}
    </span>
  </span>
);
